/**
 * Overwrite ITC function from process.js
 * @param selector
 * @param options
 */

function updateFlowContent(selector, options) {
    var defaultOptions = {
        //fieldName : $(selector).attr('name'),
        fieldName: "",
        formId: $(selector).closest("form").attr("id"),
        eventId: "updateContent",
        fragment: "content"
    };

    options = jQuery.extend(true, {}, defaultOptions, options);

    new Spring.RemotingHandler.prototype.submitForm(
        options.fieldName,
        options.formId,
        {
            _eventId: options.eventId,
            fragments: options.fragment
        }
    );
    window.setTimeout(() => {
        IVUFixTabIndex();
    }, 2000);
}
